"use client";

import React, { useEffect } from 'react';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '@/integrations/supabase/client';
import { useNavigate, useLocation } from 'react-router';
import { useAuth } from '../components/auth-provider';
import { SEO } from '../components/seo';
import { motion } from 'motion/react';

export function Login() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/admin";

  useEffect(() => {
    if (session) {
      navigate(from, { replace: true });
    }
  }, [session, navigate, from]);

  return (
    <>
      <SEO title="Admin Login" noindex={true} />
      <div className="min-h-screen bg-background flex items-center justify-center px-6">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-violet-500 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-fuchsia-500 rounded-full blur-3xl" />
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-md bg-neutral-900/50 backdrop-blur-xl border border-neutral-800 p-8 rounded-[2rem] relative z-10 shadow-2xl"
        >
          <div className="text-center mb-8">
            <h1 className="text-3xl font-black tracking-tighter uppercase italic mb-2">
              <span className="bg-gradient-to-r from-violet-500 to-fuchsia-500 bg-clip-text text-transparent">Admin</span> Access
            </h1>
            <p className="text-neutral-500 text-sm font-medium">Secure login for ergys.dev management</p>
          </div>

          <Auth
            supabaseClient={supabase}
            view="sign_in"
            showLinks={false}
            appearance={{
              theme: ThemeSupa,
              variables: {
                default: {
                  colors: {
                    brand: '#8b5cf6',
                    brandAccent: '#a78bfa',
                    inputBackground: 'transparent',
                    inputText: 'white',
                    inputBorder: '#262626',
                    inputPlaceholder: '#525252',
                  },
                },
              },
              className: {
                container: 'auth-container',
                button: 'auth-button',
                input: 'auth-input',
              }
            }}
            theme="dark"
            providers={[]}
          />
        </motion.div>
      </div>

      <style>{`
        .auth-button {
          background: white !important;
          color: black !important;
          font-weight: 900 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.1em !important;
          border-radius: 1rem !important;
          padding: 0.75rem !important;
          transition: all 0.3s !important;
        }
        .auth-button:hover {
          background: #e5e5e5 !important;
          transform: translateY(-2px) !important;
        }
        .auth-input {
          border-radius: 1rem !important;
          background: rgba(0,0,0,0.5) !important;
          border: 1px solid #262626 !important;
        }
        .auth-input:focus {
          border-color: #8b5cf6 !important;
        }
      `}</style>
    </>
  );
}